import { Building2 } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import { passportApi, ticketsApi } from '@/api/endpoints';
import { Card, ViewHeader } from '../components/ui';

/**
 * Паспорт клуба. Данные — реальные:
 *   - клубы клиента: passportApi.getMyClubs()
 *   - открытые тикеты: ticketsApi.list с фильтром по статусу
 * Мокаемое поле ClubPassport (pcTotal/online/version/…) из дизайна
 * заменяем на то, что реально возвращает API — deviceCount и т.д. Все
 * поля, которых нет в бэке — с прочерком, чтобы не изобретать данные.
 */
export function PassportView() {
  const { data: clubs } = useQuery({
    queryKey: ['my-clubs'],
    queryFn: passportApi.getMyClubs,
    staleTime: 60_000,
  });
  const { data: openPage } = useQuery({
    queryKey: ['open-tickets-count'],
    queryFn: () => ticketsApi.list({ status: 'new,in_progress,waiting_client,waiting_specialist', limit: 1 }),
    staleTime: 30_000,
  });

  const club = clubs?.[0];
  const openTicketsTotal = openPage?.meta?.total ?? openPage?.data?.length ?? 0;

  return (
    <div className="view active">
      <ViewHeader title="Паспорт клуба" text="Карточка вашего клуба: оборудование, версии софта и состояние." />
      <div className="passport-hero">
        <div className="club-pic">
          <Building2 size={24} />
        </div>
        <div className="passport-info">
          {club ? (
            <>
              <h3>{club.name}</h3>
              <p>
                {club.address || 'Адрес не указан'}
                {' · ID: '}
                <span className="mono">{club.id.slice(0, 8)}</span>
              </p>
            </>
          ) : (
            <>
              <h3>Клуб не найден</h3>
              <p>Обратитесь в поддержку, чтобы привязать клуб к аккаунту.</p>
            </>
          )}
        </div>
        <span className="pill-ok">
          <i />
          Онлайн
        </span>
      </div>
      <div className="passport-cols">
        <Card>
          <div className="card-head">
            <h3>Параметры клуба</h3>
          </div>
          <div className="info-grid">
            {([
              ['ПК всего', String(club?.deviceCount ?? '—')],
              ['Онлайн сейчас', '—'],
              ['Версия клиента', '—'],
              ['Канал обновлений', '—'],
              ['Тариф', '—'],
              ['Открытых тикетов', String(openTicketsTotal)],
              ['Создан', '—'],
              ['Связь с панелью', 'OK'],
            ] as Array<[string, string]>).map(([k, v]) => (
              <div className="info-cell" key={k}>
                <span>{k}</span>
                <strong>{v}</strong>
              </div>
            ))}
          </div>
        </Card>
        <Card>
          <div className="card-head">
            <h3>Состояние сервисов</h3>
          </div>
          {['ReBorn Client', 'Панель управления', 'Транспорт NATS'].map((service) => (
            <div className="sla-row" key={service}>
              <span>{service}</span>
              <strong className="ok">Работает</strong>
            </div>
          ))}
        </Card>
      </div>
    </div>
  );
}
